export default __webpack_public_path__ + "static/media/maruti-suzuki.65c2680c.svg";